import React from 'react';

const Product = (props) => {
  const {keyBenefits, nid, productImages, title, quantityLabels} = props.data;
  const {amounts, der, data, mealsPerDay, isMultipleProducts, productCount, wetFoodAmountLabel} = props;

  const isSupplement = data.types[0] === "supplement";

  let firstImage = false;
  if (productImages != null) {
    firstImage = productImages.find(e => true);
  }

  const quantityPerDay = getQuantity(amounts, data, mealsPerDay, wetFoodAmountLabel, quantityLabels, der);

  // Get the outer wrapepr class depending on number of products
  let productOuterWrapperClass = "col-md-12 col-lg-12";
  switch (productCount){
    case 1:
      productOuterWrapperClass = "col-md-12 col-lg-12";
      break
    case 2:
      productOuterWrapperClass = "col-md-6 col-lg-6";
      break
    case 3:
      productOuterWrapperClass = "col-md-4 col-lg-4";
      break
    case 4:
    productOuterWrapperClass = "col-md-3 col-lg-3";
    break
  }

  // Get the inner class depending on number of products
  let productInnerWrapperClass = "col-xs-12 col-sm-6";
  if (isMultipleProducts){
    productInnerWrapperClass = "col-xs-12";
  }

  let hasWetFoodAmountLabel = typeof quantityPerDay.wetFoodAmountLabel != "undefined" ? true : false;

  const isTitleTooLong = title.length > 65 ? true : false;

  return (
    <div className={"nppe2-fc-feeding-guidelines-products__item" + productOuterWrapperClass}>
      <div className="row">
        <div className={productInnerWrapperClass}>
          <div className={`nppe2-fc-feeding-guidelines-products__title${isTitleTooLong ? '-too-long' : ''}`}>{title}</div>
          {firstImage && (
            <div className="nppe2-fc-feeding-guidelines-products__img">
              <img className="img-responsive" src={firstImage} />
            </div>
          )}

          <div className="nppe2-fc-feeding-guidelines-products__data">
            {quantityPerDay &&
            <div>
              <p className="nppe2-fc-feeding-guidelines-products__per-day">{quantityPerDay.perDay}</p>
              {!isSupplement &&
                <p className="nppe2-fc-feeding-guidelines-products__per-meal">{quantityPerDay.perMeal}</p>
              }
              {hasWetFoodAmountLabel &&
                <p className="nppe2-fc-feeding-guidelines-products__wet-food-amount-label">{quantityPerDay.wetFoodAmountLabel}</p>
              }
            </div>}
          </div>
        </div>

        {!isMultipleProducts && (
          <div className="col-xs-12 col-sm-6">
            <ul className="nppe2-fc-feeding-guidelines-products__info">
              {keyBenefits && keyBenefits.map((benefit, benefitIndex) => (
                <li key={benefitIndex}>
                  <p><span>{benefit.title}</span></p>
                </li>
              ))}
            </ul>
          </div>
        )}

      </div>
    </div>

  );
}


const getQuantity = (amounts, product, mealsPerDay, wetFoodAmountLabel, quantityLabels, derValue) => {
  const isDry = product.types.includes("dry");
  const isWet = product.types.includes("wet");
  const isSnack = product.types.includes("snack");
  const isRelated = product.types.includes("related") || product.types.includes("supplement");

  if (isDry){
    let dryOutput = {
      "perDay": amounts.dryGrams + " " + quantityLabels[0],
      "perMeal": (amounts.dryGrams / mealsPerDay).toFixed(0) + " " + quantityLabels[1],
    }

    return dryOutput;
  }

  if (isWet){
    let wetOutput = {
      "perDay": amounts.wetGrams + " " + quantityLabels[0],
      "perMeal": (amounts.wetGrams / mealsPerDay).toFixed(0) + " " + quantityLabels[1],
      "wetFoodAmountLabel": wetFoodAmountLabel,
    }

    return wetOutput;
  }

  if (isRelated){
    let otherOutput = {};

    if (product.title.toLowerCase().includes("hydra")) {
      const productEnergyPerPackage = parseFloat(product.energyPerPackage);
      const quantityPouches = parseFloat((Math.round(((derValue?.der * 0.1) / productEnergyPerPackage)*2)/2).toFixed(1))

      return otherOutput = {
        "perDay": quantityPouches.toString().replace('.0', '') + " " + ((quantityPouches > 1) ? quantityLabels[6] : quantityLabels[5]),
        "perMeal": ""
      }
    } else {
        return otherOutput = {
          "perDay": product.unitsPerDay + " " + quantityLabels[2],
          "perMeal": (product.unitsPerDay / mealsPerDay).toFixed(0) + " " + quantityLabels[3],
        }
    }
  }

  if (isSnack){
    let otherOutput = {};

    if (product.gramsPerUnit != null && typeof product.gramsPerUnit != "undefined"){
      let snackKcal = amounts.snackKcal;                  // 250
      let energyPerHundered = product.energyPerHundred;   // 125
      let productGrams = (snackKcal / energyPerHundered) * 100;
      let unitsForGrams = (productGrams / product.gramsPerUnit).toFixed(1); // Number of units

      otherOutput = {
        "perDay": unitsForGrams + " " + quantityLabels[2],
        "perMeal": (unitsForGrams / mealsPerDay).toFixed(1) + " " + quantityLabels[3],
      }
    } else {
      otherOutput = {
        "perDay": product.unitsPerDay + " " + quantityLabels[2],
        "perMeal": (product.unitsPerDay / mealsPerDay).toFixed(1) + " " + quantityLabels[3],
      }
    }

    return otherOutput;
  }

  return null;
}

export default Product;
